import { FormLabelProps } from '@/components/elements/FormLabel'

export const irLabels: {
  company: FormLabelProps
  fullName: FormLabelProps
  firstName: FormLabelProps
  lastName: FormLabelProps
  email: FormLabelProps
  tel: FormLabelProps
  title: FormLabelProps
  detail: FormLabelProps
} = {
  company: {
    text: 'Company',
    isRequired: false,
    inputId: 'company',
  },
  fullName: {
    text: 'Name',
    isRequired: true,
    inputId: 'lastName',
  },
  firstName: {
    text: 'First name',
    isRequired: 'none',
    inputId: 'firstName',
  },
  lastName: {
    text: 'Last name',
    isRequired: 'none',
    inputId: 'lastName',
  },
  email: {
    text: 'Email Address',
    isRequired: true,
    inputId: 'email',
  },
  tel: {
    text: 'Phone Number',
    isRequired: false,
    inputId: 'tel',
  },
  title: {
    text: 'Subject',
    isRequired: false,
    inputId: 'title',
  },
  detail: {
    text: 'Message',
    isRequired: true,
    inputId: 'detail',
  },
}

export const formData = {
  company: '',
  lastName: 'トライアル',
  firstName: '太郎',
  email: 'XXX@XXX.ne.jp',
  title: '件名が入りますダミー',
  detail:
    'ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。',
}
